export default {"src":"/_next/static/media/azuro-coin.9c545e9b.gif","height":188,"width":188,"blurWidth":0,"blurHeight":0};